import { CorporateAdminStatus } from '../../enums';

export interface CreateCorporateAdminDto {
  locationId?: string | null; // Guid
  positionId?: string | null; // Guid
  roleId?: string | null; // Guid
  firstName: string; // Required, max 100
  lastName: string; // Required, max 100
  email: string; // Required, email, max 320
  contactNumber?: string;
  hireDate: string; // Required, DateOnly as ISO string (YYYY-MM-DD)
  status?: CorporateAdminStatus; // Default: Active
  isActive?: boolean; // Default: true
}
